module.exports = __webpack_public_path__ + "img/flame_2.7759a21b.png";